import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOnePaymentPayload {
    paymentId: string
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneSubscriptionPayment = createSlice({
    name: 'subscriptions/one-subscription-payment',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOnePaymentPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const onePaymentActions = oneSubscriptionPayment.actions
export default oneSubscriptionPayment.reducer
